"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCard = function ContentCard(_ref) {
  var children = _ref.children,
      orientation = _ref.orientation,
      className = _ref.className,
      mark = _ref.mark;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "content-card ".concat(orientation, " ").concat(className, " ").concat(mark)
  }, children);
};

var _default = ContentCard;
exports.default = _default;
ContentCard.propTypes = {
  children: _propTypes.default.any.isRequired,
  orientation: _propTypes.default.oneOf(['vertical', 'horizontal', 'vertical-horizontal', 'horizontal-vertical']).isRequired,
  className: _propTypes.default.string,
  mark: _propTypes.default.oneOf(['close', 'primary', 'none'])
};
ContentCard.defaultProps = {
  mark: 'none'
};